// Shared by the auth pages (Login, Register). Keep the redirect validation in
// one place — it is security-sensitive and easy to drift.

// Resolve ?returnTo= to a safe same-origin path, else "/".
//
// The same-origin check alone is not enough: a value like /.//evil.com or
// /\evil.com parses same-origin but normalizes to a protocol-relative
// //evil.com when assigned to location.href — an open redirect. So require the
// resolved path to be exactly one leading slash (no "//" prefix, no backslash).
//
// The Base44 version also stripped app_id / app_base_url / access_token and
// friends, because app-params.js persisted those from the URL into
// localStorage: a crafted returnTo could repoint the app at an attacker's
// backend. The backend is a build-time constant now and app-params.js is gone,
// so that particular attack surface no longer exists — but the origin check
// below still matters and must not be dropped.
export function safeReturnTo() {
  const raw = new URLSearchParams(window.location.search).get("returnTo");
  if (!raw) return "/";
  try {
    const url = new URL(raw, window.location.origin);
    if (url.origin !== window.location.origin) return "/";
    const path = url.pathname + url.search;
    if (!path.startsWith("/") || path.startsWith("//") || path.includes("\\")) return "/";
    return path;
  } catch {
    return "/";
  }
}
